import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncUpdateResources, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import { transformResponseToTags, transformTagToRequestData, transformTagsToRequestData } from './transformers';


// ===============================================================================================
// SAGAS functions for tags.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'tag',
  resourceBaseUrl: '/tags',
  getLastSyncDate,

  transformResponseToResources: transformResponseToTags,
  transformResourceToRequestData: transformTagToRequestData,
  transformResourcesToRequestData: transformTagsToRequestData,

  successAction,
  failureAction,
});

export function* getTagsActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getTags);

    const config = mkResourceConfig(actions.getTagsSuccess, actions.getTagsFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createTagActionWatcher() {
  const config = mkResourceConfig(actions.createTagSuccess, actions.createTagFailure);
  yield takeEvery(actions.createTag, qcsSyncCreateResource, config);
}

export function* batchTags(action) {
  let config = mkResourceConfig(actions.batchTagsSuccess, actions.batchTagsFailure);
  if (action.meta && action.meta.axiosConfig) {
    config = config.set('axiosConfig', action.meta.axiosConfig);
  }
  yield call(qcsSyncUpdateResources, config, action);
}

export function* batchTagsActionWatcher() {
  yield takeEvery(actions.batchTags, batchTags);
}

export function* updateTagActionWatcher() {
  const config = mkResourceConfig(actions.updateTagSuccess, actions.updateTagFailure);
  yield takeEvery(actions.updateTag, qcsSyncUpdateResource, config);
}

export function* deleteTagActionWatcher() {
  const config = mkResourceConfig(actions.deleteTagSuccess, actions.deleteTagFailure);
  yield takeEvery(actions.deleteTag, qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getTagsActionWatcher,
  createTagActionWatcher,
  batchTagsActionWatcher,
  updateTagActionWatcher,
  deleteTagActionWatcher,
];
